/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { useIntl } from 'react-intl'
import PageTitle from '../../../../client/js/components/PageTitle'
import EstateListTemplateField from '../fields/EstateListTemplateField'
import InvoiceTemplateList from '../invoice/InvoiceTemplateList'
import ManagementReportTemplateField from '../fields/ManagementReportTemplateField'
import { Card, Container, Stack } from '@mantine/core'
import FormSection from '../FormSection'
import Page from '../../../../client/js/components/Page'
import AdminBreadcrumb from '../../../../client/js/components/breadcrumb/AdminBreadcrumb'
import BreadcrumbCard from '../../../../client/js/components/breadcrumb/BreadcrumbCard'

function TemplateSettingsPage () {
  const intl = useIntl()

  const title = intl.formatMessage({
    id: 'document_templates',
    defaultMessage: 'Modèles de document'
  })

  return (
    <Page>
      <Container size="xl">
        <PageTitle
          hidden
          title={title}
        />

        <BreadcrumbCard>
          <AdminBreadcrumb>
                <span>
                  {intl.formatMessage({
                    id: 'settings',
                    defaultMessage: 'Paramètres'
                  })}
                </span>
            <span>{title}</span>
          </AdminBreadcrumb>
        </BreadcrumbCard>

        <Card shadow="sm">
          <Stack>
            <FormSection
              id="estate-templates"
              defaultOpened
              title={intl.formatMessage({
                id: 'estates',
                defaultMessage: 'Biens'
              })}
            >
              <EstateListTemplateField />
            </FormSection>

            <FormSection
              id="report-templates"
              defaultOpened
              title={intl.formatMessage({
                id: 'reports',
                defaultMessage: 'Rapports'
              })}
            >
              <ManagementReportTemplateField />
            </FormSection>

            <FormSection
              id="invoice-templates"
              defaultOpened
              title={intl.formatMessage({
                id: 'invoices',
                defaultMessage: 'Factures'
              })}
            >
              <InvoiceTemplateList />
            </FormSection>
          </Stack>
        </Card>
      </Container>
    </Page>
  )
}

export default TemplateSettingsPage
